import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  modelValue: {
    type: Object,
    default: {
      pid:'',
      cid: '',
      mid: ''
    }
  }
},
  emits: [ 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const secondInputRef = ref()
const thirdInputRef = ref()
const ids = ref({
  pid: '',
  cid: '',
  mid: ''
})





watch(()=>props.modelValue, (newVal, oldVal)=> {
  //试试输入的值
  // console.log('nnnnnn',newVal)  
  ids.value.cid = newVal.cid
  ids.value.pid = newVal.pid
  ids.value.mid = newVal.mid
},{
  immediate:true,
  deep: true
})

watch(()=>ids.value, (newVal, oldVal) => {
  // console.log('ids',newVal);
  //监听对象的变化，返回更新值
  emit('update:modelValue', newVal)
}, {
  immediate:true,
  deep: true
})

/** 监听键盘弹起，自动对焦下一个输入框 */
const onFirstKeyup = () => {
  if(String(ids.value.pid).length===3) {
    secondInputRef.value.focus()
  } 
}

const onSecondKeyup = () => {
  if(String(ids.value.cid).length===3) {
    thirdInputRef.value.focus()
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_input, {
      modelValue: ids.value.pid,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ids.value.pid) = $event)),
      modelModifiers: { number: true },
      style: {"width":"201px","margin-right":"15px"},
      oninput: "value=value.replace(/^[^\\d]+/g,'')",
      maxlength: "3",
      onKeyup: onFirstKeyup
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      ref_key: "secondInputRef",
      ref: secondInputRef,
      modelValue: ids.value.cid,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ids.value.cid) = $event)),
      style: {"width":"201px","margin-right":"15px"},
      oninput: "value=value.replace(/^[^\\d]+/g,'')",
      maxlength: "3",
      onKeyup: onSecondKeyup
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      ref_key: "thirdInputRef",
      ref: thirdInputRef,
      modelValue: ids.value.mid,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ids.value.mid) = $event)),
      style: {"width":"201px"},
      oninput: "value=value.replace(/^[^\\d]+/g,'')",
      maxlength: "3"
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})